import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FileUploadResponse } from '../models/file-upload.model';

/**
 * Servicio de almacenamiento de archivos — POST /api/files/upload.
 *
 * NOTA multi-tenant: el businessId y userId salen del JWT (el interceptor de
 * auth ya adjunta el Bearer). NO se envían por query ni body.
 *
 * Para adjuntos de correo NO se manda entityId/entityType: la `category` queda
 * en su default GENERAL (acepta cualquier tipo permitido). Límite 10 MB por
 * archivo (validar también en cliente antes de subir).
 */
@Injectable({
  providedIn: 'root',
})
export class FileApiService {
  private readonly apiUrl = `${environment.apiUrl}api/files`;

  constructor(private http: HttpClient) {}

  /**
   * Sube un archivo. Devuelve la metadata con el `fileId` a usar como
   * storageRef en el envío del correo.
   */
  uploadFile(file: File): Observable<FileUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<FileUploadResponse>(`${this.apiUrl}/upload`, formData);
  }

  /**
   * Sube una imagen PÚBLICA para incrustarla inline en el cuerpo de un correo.
   * Usa la misma receta que los assets del editor de plantillas
   * (category=TEMPLATE_ASSET, isPublic=true): devuelve un `publicUrl` absoluto
   * (/api/files/{id}/download, permitAll) que el destinatario puede cargar sin
   * autenticación al abrir el mensaje.
   */
  uploadPublicImage(file: File): Observable<FileUploadResponse> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const params = new HttpParams()
      .set('category', 'TEMPLATE_ASSET')
      .set('isPublic', 'true');
    return this.http.post<FileUploadResponse>(`${this.apiUrl}/upload`, formData, { params });
  }
}
